import React from 'react';
import TabRouting from '../../components/TabRouting';

const selectedMainTabIndex = 7;
const DispositionMainPage = () => {
    return <TabRouting selectedMainTabIndex={selectedMainTabIndex}></TabRouting>;
};

export default DispositionMainPage;
